import styles from './latestProducts.scss';
import { NO_ELEMENT, hasElements } from 'utils';
import { Section } from 'components/Section';
import { LatestProductsBlock } from 'models/LatestProductsBlock';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { useDispatch } from 'react-redux';
import { useIntersectionObserver } from 'hooks';
import { TrackedElement } from 'hooks/useIntersectionObserver';
import { GtmViewListItem } from 'store/googleTagManager/actions';
import {
  getLastViewedListName,
  mapListViewProductToGtm
} from 'store/googleTagManager/events/utils';
import { ProductsCardGrid } from './productsCardGrid';

export const LatestProducts = ({ products, title }: LatestProductsBlock) => {
  const reduxDispatch = useDispatch();
  const { setElementRef } = useIntersectionObserver({
    onBatchVisible: handleElementsVisible
  });

  if (!hasElements(products)) {
    return NO_ELEMENT;
  }

  function handleElementsVisible(elements: TrackedElement<ProductlistViewProduct>[]) {
    const gtmItemProducts = elements.map(element => {
      const viewedProduct = element.payload;
      const listName = getLastViewedListName(viewedProduct.productId, viewedProduct.title);
      const indexInList = products.indexOf(viewedProduct);

      return mapListViewProductToGtm({
        product: viewedProduct,
        indexInList,
        listName
      });
    });

    reduxDispatch(GtmViewListItem({ gtmItemProducts }));
  }

  return (
    <Section title={title} className={styles.section}>
      <ProductsCardGrid products={products} setElementRef={setElementRef} />
    </Section>
  );
};
